import { APP_BASE_HREF } from '@angular/common';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { HammerGestureConfig, HammerModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { provideLoaders } from '@frontend/loaders';
import { AppComponent, STORE_PREFIX, bootloader, provideVanillaCore, runOnAppInit } from '@frontend/vanilla/core';
import { providePokerSrc } from '@pokercore/module';
import { providePokerCoreFeatures } from '@pokercore/module/core';

import { appRoutes } from './app.routes';
import { environment } from './environments/environment';
import { PokerBootstrapService } from './poker-bootstrap/poker-bootstrap.service';

if (environment.production) {
    enableProdMode();
}

export class HammerConfig extends HammerGestureConfig {
    override overrides = <any>{
        swipe: { enable: true, direction: Hammer.DIRECTION_ALL },
    };
}

bootloader().then(() => {
    bootstrapApplication(AppComponent, {
        providers: [
            provideRouter(appRoutes),
            provideAnimations(),
            provideVanillaCore(),
            provideLoaders(),
            providePokerSrc(),
            providePokerCoreFeatures(),
            importProvidersFrom(HammerModule),
            runOnAppInit(PokerBootstrapService),
            { provide: STORE_PREFIX, useValue: 'poker.' },
            { provide: MatDialogRef, useValue: {} },
            { provide: APP_BASE_HREF, useValue: '/' },
        ],
    })
        // eslint-disable-next-line no-console
        .catch((err) => console.error(err));
});
